import { render, staticRenderFns } from "./Vacature.vue?vue&type=template&id=58f924d7"
import script from "./Vacature.vue?vue&type=script&lang=js"
export * from "./Vacature.vue?vue&type=script&lang=js"
import style0 from "./Vacature.vue?vue&type=style&index=0&id=58f924d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports